module.exports = __webpack_public_path__ + "static/img/huishengzhaopin.799dd9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huishengzhaopin.jpg
// module id = v0ZW
// module chunks = 1